import { cn } from "@common/lib/utils"

interface LoadingSpinnerProps {
  className?: string
  /** Size of the spinner in pixels. Defaults to 20 (same as h-5 w-5) */
  size?: number
}

/**
 * GitHub Actions-style loading spinner with animated circular progress
 */
export function LoadingSpinner({ className, size = 20 }: LoadingSpinnerProps) {
  const strokeWidth = 2
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  // Show approximately 25% of the circle as the active segment
  const dashLength = circumference * 0.25

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={cn("animate-spin", className)}
      style={{ animationDuration: "1s" }}
    >
      {/* Background circle (track) */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        opacity={0.2}
      />
      {/* Animated segment */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={`${dashLength} ${circumference - dashLength}`}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  )
}
